import * as React from 'react';
import './index.less';
import ABSSection from '../../../../../../../components/ABSSection';

export default class PrivacyAgreement extends React.Component<any, any> {
  render() {
    return (
      <div className="abs-domestic-agreement">
        <div className="abs-domestic-agreement-title">
          CNABS 用户隐私协议
        </div>
        <div className="abs-domestic-agreement-content">
          <ABSSection content={'本指引是CNABS平台“中诚信和逸信息科技(上海)有限公司”（以下简称“平台”）为处理您的个人隐私信息而制定。'} />
          <ABSSection title={'平台处理的信息'} content={'平台会按照注册、登录、认证、找回，方式收集您在使用服务时主动提供的信息。包括：姓名、手机号、邮箱以及用户自主完善的个人基本信息。平台将在您授权同意的范围内使用您的相关信息。'} />
          <ul>
            <li>
              为了注册、登录，平台将在获取您的明示同意后，收集您的手机号。
            </li>
            <li>
              平台收集您选中的文件，用于唯一信息确认。
            </li>
            <li>
              平台收集您的邮箱，用于及时回复您的反馈意见。
            </li>
            <li>
              平台收集您选中的照片或视频信息，用于“我的”页面实现上传头像，完善用户信息。
            </li>
            <li>
              平台收集您的操作日志，用于运营维护。
            </li>
          </ul>

          <ABSSection title={'平台对信息的存储'} content={'CNABS承诺，除法律法规另有规定外，平台对您的信息的保存期限应当为实现处理目的所必要的最短时间。'} />
          <ABSSection title={'信息的使用规则'} >
            <p>平台将会在本指引所明示的用途内使用收集的信息。</p>
            <p>如平台使用您的信息超出本指引目的或合理范围，平台必须在变更使用目的或范围前，再次以弹层方式告知并征得您的明示同意。</p>
          </ABSSection>
          <ABSSection title={'信息对外提供'}>
            <p>平台承诺，不会主动共享或转让您的信息至任何第三方，如存在确需共享或转让时，平台应当直接征得或确认第三方征得你的单独同意。</p>
            <p>平台承诺，不会对外公开披露您的信息，如必须公开披露时，平台应当向您告知公开披露的目的、披露信息的类型及可能涉及的信息，并征得您的单独同意。</p>
          </ABSSection>
          <ABSSection title={'若你认为平台未遵守上述约定，或有其他的建议，可通过以下方式与平台联系；'} content={'- 邮箱: feedback@cn-abs.com'} />
          <ABSSection title={''} content={'更新日期：2025年9月15日'} />
          <ABSSection title={''} content={'生效日期：2025年9月15日'} />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/account/Register/Domestic/Phone/PrivacyAgreement/index.tsx